import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { useContent } from "../ContentContext";
import { useAuth } from "../context/AuthContext";
import { useCart } from "../context/CartContext";
import { useWishlist } from "../context/WishlistContext";
import AddressStrip from "./AddressStrip";
import NotificationBell from "./NotificationBell";

function DesktopItem({ item }) {
  if (item.mega) {
    return (
      <li>
        <a href="#products" onClick={(e) => e.preventDefault()}>
          <i className={`fas ${item.icon}`} /> {item.label}
          <i className="fa fa-angle-down caret" />
        </a>
        <div className="mega-menu">
          {item.mega.map((col) => (
            <div className="mega-column" key={col.title}>
              <h4>
                <i className={`fas ${col.icon}`} /> {col.title}
              </h4>
              <ul>
                {col.links.map((l) => (
                  <li key={l.to}>
                    <Link to={l.to}>
                      <i className={`fas ${l.icon}`} /> {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </li>
    );
  }

  if (item.submenu) {
    return (
      <li>
        <a href="#menu" onClick={(e) => e.preventDefault()}>
          <i className={`fas ${item.icon}`} /> {item.label}
          <i className="fa fa-angle-down caret" />
        </a>
        <ul className="submenu">
          {item.submenu.map((l) => (
            <li key={l.to}>
              <Link to={l.to}>
                <i className={`fas ${l.icon}`} /> {l.label}
              </Link>
            </li>
          ))}
        </ul>
      </li>
    );
  }

  return (
    <li>
      <NavLink to={item.to} end={item.to === "/"}>
        <i className={`fas ${item.icon}`} /> {item.label}
      </NavLink>
    </li>
  );
}

function MobileItem({ item, onNavigate }) {
  const [open, setOpen] = useState(false);
  const children = item.mega || item.submenu;

  if (!children) {
    return (
      <Link className="m-link" to={item.to} onClick={onNavigate}>
        <span>
          <i className={`fas ${item.icon}`} /> {item.label}
        </span>
      </Link>
    );
  }

  return (
    <div className="mobile-dropdown">
      <button onClick={() => setOpen((o) => !o)}>
        <span>
          <i className={`fas ${item.icon}`} /> {item.label}
        </span>
        <i className={`fa fa-angle-${open ? "up" : "down"}`} />
      </button>
      {open ? (
        <div className="mobile-sub">
          {item.mega
            ? item.mega.map((col) => (
                <div key={col.title}>
                  <h5>{col.title}</h5>
                  {col.links.map((l) => (
                    <Link key={l.to} to={l.to} onClick={onNavigate}>
                      {l.label}
                    </Link>
                  ))}
                </div>
              ))
            : item.submenu.map((l) => (
                <Link key={l.to} to={l.to} onClick={onNavigate}>
                  {l.label}
                </Link>
              ))}
        </div>
      ) : null}
    </div>
  );
}

export default function Header({ onEnquiry }) {
  const { company, nav } = useContent();
  const { isLoggedIn, user } = useAuth();
  const { count: cartCount } = useCart();
  const { count: wishCount } = useWishlist();
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);

  return (
    <>
      {/* Utility bar: delivery location on the left, shop actions on the right */}
      <div className="util-bar">
        <div className="util-inner">
          <AddressStrip />

          <div className="util-actions">
            <NotificationBell />

            <Link className="util-icon" to="/wishlist" aria-label="Wishlist">
              <i className="far fa-heart" />
              {wishCount > 0 ? (
                <span className="badge">
                  {wishCount > 9 ? "9+" : wishCount}
                </span>
              ) : null}
              <span className="util-label">Wishlist</span>
            </Link>

            <Link className="util-icon" to="/cart" aria-label="Cart">
              <i className="fas fa-cart-shopping" />
              {cartCount > 0 ? (
                <span className="badge">
                  {cartCount > 9 ? "9+" : cartCount}
                </span>
              ) : null}
              <span className="util-label">Cart</span>
            </Link>

            <Link
              className="util-icon"
              to={isLoggedIn ? "/account" : "/login"}
              aria-label="Account"
            >
              <i className="fas fa-user" />
              <span className="util-label">
                {isLoggedIn ? user?.name?.split(" ")[0] || "Account" : "Login"}
              </span>
            </Link>
          </div>
        </div>
      </div>

      <header className="header">
        <div className="header-container">
          <div className="logo">
            <Link to="/">
              <img src={company.logo} alt={company.name} />
            </Link>
          </div>

          <nav className="navbar">
            <ul className="menu">
              {nav.map((item) => (
                <DesktopItem key={item.label} item={item} />
              ))}
            </ul>
          </nav>

          <button className="consult-btn" onClick={onEnquiry}>
            <i className="fas fa-gift" /> Get Free Sample Today
          </button>

          <button
            className="menu-toggle"
            onClick={() => setOpen(true)}
            aria-label="Open menu"
          >
            <i className="fas fa-bars" />
          </button>
        </div>
      </header>

      {open ? <div className="backdrop" onClick={close} /> : null}
      <div className={`mobile-menu ${open ? "open" : ""}`}>
        <div className="mobile-header">
          <h3>Menu</h3>
          <button
            className="close-menu"
            onClick={close}
            aria-label="Close menu"
          >
            <i className="fas fa-xmark" />
          </button>
        </div>
        {nav.map((item) => (
          <MobileItem key={item.label} item={item} onNavigate={close} />
        ))}
        <button
          className="consult-btn"
          style={{ width: "100%", marginTop: 18 }}
          onClick={() => {
            close();
            onEnquiry();
          }}
        >
          Get Free Sample Today
        </button>
      </div>
    </>
  );
}
